import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function Swatches({ theme }) {
  return (
    <div className="flex flex-shrink-0 items-center gap-1">
      {[theme.primaryColor, theme.inkColor, theme.paperColor].map((color) => (
        <span
          key={color}
          className="h-3.5 w-3.5 rounded-full border border-k-gray/60"
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
  );
}

export default function ExportThemeSwitcher({ options, value, onChange }) {
  const { t } = useTranslation('trips');
  const [open, setOpen] = useState(false);

  const selected = options.find((option) => option.key === value) ?? options[0];

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="export-hidden fixed bottom-4 right-4 z-popover rounded-md border border-k-gray bg-white px-3 py-2 text-2xs font-semibold uppercase tracking-widest text-[var(--td-ink)] shadow-sm"
      >
        {t('export.preview.theme.pill')} · {selected?.name}
      </button>
    );
  }

  return (
    <div className="export-hidden fixed bottom-4 right-4 z-popover w-64 rounded-md border border-k-gray bg-white p-3 shadow-md">
      <div className="flex items-center justify-between">
        <div className="text-2xs font-semibold uppercase tracking-widest text-[var(--td-primary)]">
          {t('export.preview.theme.title')}
        </div>
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label={t('export.preview.theme.close')}
          className="appearance-none bg-transparent border-0 p-0 m-0 outline-none cursor-pointer leading-none text-[var(--td-ink-muted)]"
        >
          ✕
        </button>
      </div>

      <div className="mt-3 space-y-2">
        {options.map((option) => (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange(option.key)}
            className={`flex w-full items-center gap-3 rounded-md border px-3 py-2 text-left ${
              option.key === value
                ? 'border-[var(--td-primary)] bg-[var(--td-primary-soft)]'
                : 'border-k-gray/60 bg-white'
            }`}
          >
            <Swatches theme={option.theme} />
            <div className="min-w-0">
              <div className="truncate text-sm font-medium text-[var(--td-ink)]">
                {option.name}
              </div>
              <div className="truncate text-2xs text-[var(--td-ink-muted)]">
                {option.theme.displayFont} · {option.theme.bodyFont}
              </div>
            </div>
          </button>
        ))}
      </div>

      <div className="mt-3 text-2xs italic text-[var(--td-ink-muted)]">
        {t('export.preview.theme.note')}
      </div>
    </div>
  );
}
